export default "__VITE_ASSET__DKMuk2a4__"